import type React from 'react';

import * as styles from './styles';

import { ContentLoader } from '../../ContentLoader';

export interface TableLoadingProps {
  numOfRows?: number;
  numOfColumns?: number;
  justify?: boolean;
  filter?: boolean;
  className?: string;
}

const Filter = () => (
  <div className={styles.filter}>
    <ContentLoader width={320} height={59}>
      <rect x='20' y='0' width='300' height='20' />
    </ContentLoader>
  </div>
);

const Titles = (numOfColumns: number, justify: boolean) => (
  <div className={styles.row(justify)}>
    {Array.from({ length: numOfColumns }, (x, i) => i).map((index) => {
      if (index === 0) {
        return (
          <ContentLoader key={index} width={280} height={30}>
            <rect x='20' y='0' width='140' height='20' />
          </ContentLoader>
        );
      }
      if (index === numOfColumns - 1) {
        return (
          <ContentLoader key={index} width={160} height={30}>
            <rect x='0' y='0' width='140' height='20' />
          </ContentLoader>
        );
      }
      return (
        <ContentLoader key={index} width={176} height={30}>
          <rect x='0' y='0' width='140' height='20' />
        </ContentLoader>
      );
    })}
  </div>
);

const Row = (key: number, numOfColumns: number, justify: boolean) => (
  <div key={key} className={styles.contentRow(justify)}>
    {Array.from({ length: numOfColumns }, (x, i) => i).map((index) => {
      if (index === 0) {
        return (
          <ContentLoader key={index} width={280} height={37}>
            <rect x='20' y='0' width='180' height='20' />
          </ContentLoader>
        );
      }
      if (index === numOfColumns - 1) {
        return (
          <ContentLoader key={index} width={160} height={37}>
            <rect x='40' y='0' width='100' height='20' />
          </ContentLoader>
        );
      }
      return (
        <ContentLoader key={index} width={176} height={37}>
          <rect x='40' y='0' width='100' height='20' />
        </ContentLoader>
      );
    })}
  </div>
);

export const TableLoading: React.FC<TableLoadingProps> = ({
  numOfRows = 10,
  numOfColumns = 5,
  justify = true,
  filter,
  className,
}) => (
  <div className={className}>
    {filter && <Filter />}
    {Titles(numOfColumns, justify)}
    {Array.from({ length: numOfRows }, (x, i) => i).map((index) =>
      Row(index, numOfColumns, justify)
    )}
  </div>
);
